import React from 'react';
import LoadingWrapper from '../../../../../components/LoadingWrapper';

const BrowserAuth = ({ isLoading }) => {
    return <LoadingWrapper isLoading={isLoading}>{null}</LoadingWrapper>;
};

export default BrowserAuth;
